<template>
     <div>
       <v-container>
           <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_Applicants")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">
                   <template v-for="(applicant, index) in deal.Applicants">
                       <span v-bind:key="index">{{applicant.Name}}</span>
                       <span v-bind:key="index" v-show="index + 1 < deal.Applicants.length">, </span>
                   </template>
               </v-col>
           </v-row>
           <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_SubjectPropertyAddress")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.FullPropertyAddress}}</span>                
               </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_ApplicationDate")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.ApplicationDate}}</span>                
               </v-col>
           </v-row>
           <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_ApplicationType")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.ApplicationType}}</span>                
               </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_ApplicationPurpose")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.Purpose}}</span>                
               </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_ApplicationStatus")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.MortgageApplicationStatus}}</span>                
               </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_InterestRate")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span v-show="deal.InterestRate">{{deal.InterestRate}}%</span>                
               </v-col>
           </v-row>          
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_ClosingDate")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.ClosingDate}}</span>                
               </v-col>
           </v-row>
             <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_MaturityDate")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.MaturityDate}}</span>                
               </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_Term")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                    <span>{{deal.Term}}</span><span v-show="deal.Term">&nbsp; {{$t("labels.MTG_Months")}}</span>              
                </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_Amortization")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.Amortization}}<span v-show="deal.Amortization">&nbsp; {{$t("labels.MTG_Months")}}</span> </span>                
               </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_RateType")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.RateType}}</span>                
               </v-col>
           </v-row>
           <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_PaymentFrequency")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.PaymentFrequency}}</span>                
               </v-col>
           </v-row>
             <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_PaymentAmount")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                       <span>{{deal.PaymentAmount}}</span>                
               </v-col>
           </v-row>
            <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_Insured")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                  <span v-show="deal.InsuredFl ">{{$t("labels.Yes")}}</span>   
                  <span v-show="!deal.InsuredFl ">{{$t("labels.No")}}</span>                 
               </v-col>
           </v-row>
           <v-row v-show="deal.InsuredFl">
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_InsurancePremium")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                  <span>{{deal.InsurancePremium}}</span>                
               </v-col>
           </v-row>
           <v-row>
               <v-col lg="4" md="4" sm="5">
                  <span class="font-weight-black">{{$t("labels.MTG_LenderName")}}</span>
               </v-col>
                <v-col lg="8" md="8" sm="7">                  
                  <span>{{deal.LenderName}}</span>                            
               </v-col>
           </v-row>
       </v-container>
    </div>
</template>
<script>
export default {
    props:["deal"]
}
</script>
<style scoped>

</style>